import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { Bar } from 'react-chartjs-2';

const useStyles = makeStyles((theme) => ({
  box: {
    padding: '20px 15px',
    display: 'flex',
    height: 400,
    justifySelf: 'stretch',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      height: 'auto',
    },
  },
  description: {
    flexBasis: '25%',
    display: 'flex',
    flexDirection: 'column',
    marginRight: 10,
  },
  libBar: {
    maxHeight: '100%',
    maxWidth: '100%',
  },
  label: {
    marginBottom: 15,
    color: 'rgba(0, 0, 0, 0.65)',
    fontSize: '0.8rem',
  },
  title: {
    marginBottom: '5px',
    lineHeight: '150%',
    letterSpacing: '0.15px',
    fontSize: '1.2rem',
  },
  text: {
    color: 'rgba(0, 0, 0, 0.65)',
    fontSize: '0.7rem',
  },
  chart: {
    flexBasis: '75%',
    display: 'flex',
    alignItems: 'end',
    [theme.breakpoints.down('md')]: {
      marginTop: 20,
    },
  },
  noData: {
    flexBasis: '75%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.3rem',
  },
}));

const CircularChart = ({
  dateStart,
  dateEnd,
  gridArea,
  label,
  title,
  text,
  votesPerDay,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const [validatedVotesPerDay, setValidatedVotesPerDay] = useState([]);

  const dateMaker = (date) => {
    return new Date(date);
  };

  const dateValidation = (elem) => {
    const correctDate = dateMaker(elem.str_date_val);
    return (
      correctDate >= dateMaker(dateStart) && correctDate <= dateMaker(dateEnd)
    );
  };

  const data = {
    labels: validatedVotesPerDay.map((elem) => elem.str_date),
    datasets: [
      {
        label: 'Liczba osób głosujących',
        data: validatedVotesPerDay.map((elem) => elem.count),
        backgroundColor: validatedVotesPerDay.map(
          () => theme.palette.primary.dark,
        ),
        borderColor: validatedVotesPerDay.map(() => theme.palette.primary.dark),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  useEffect(() => {
    if (votesPerDay) {
      const tempVotesPerDay = votesPerDay.filter(dateValidation);
      setValidatedVotesPerDay(tempVotesPerDay);
    }
  }, [votesPerDay]);

  return (
    <Box className={classes.box} style={{ gridArea: gridArea }} boxShadow={3}>
      <div className={classes.description}>
        <p className={classes.label}>{label}</p>
        <p className={classes.title}>{title}</p>
        <p className={classes.text}>{text}</p>
      </div>
      {validatedVotesPerDay.length > 0 ? (
        <div className={classes.chart}>
          <Bar className={classes.libBar} data={data} options={options} />
        </div>
      ) : (
        <div className={classes.noData}>
          <div>
            Brak danych w przedziale od {dateStart} do {dateEnd}.
          </div>
        </div>
      )}
    </Box>
  );
};

export default CircularChart;
